/**
 * When .env has a non-localhost host, use it (deployed APIs).
 * When .env is localhost (local CraneSoftware), keep that port — do not rewrite
 * to window.location.origin (the CRA UI), or Node/Java calls 404 on :3002.
 */
export function resolveServiceBaseUrl(envValue, fallback) {
  const envUrl = (envValue || '').trim().replace(/\/$/, '');
  const isLocalEnv = /localhost|127\.0\.0\.1/i.test(envUrl);
  if (envUrl && !isLocalEnv) {
    return envUrl;
  }
  if (envUrl && (process.env.NODE_ENV !== 'production' || isLocalEnv)) {
    return envUrl;
  }
  if (typeof window !== 'undefined' && window.location?.origin && process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  return envUrl || fallback;
}

export const getNodeServiceBaseUrl = () =>
  resolveServiceBaseUrl(
    process.env.REACT_APP_NODE_SERVICE_BASE_URL,
    'http://localhost:8081'
  );

export const getSwaggerServiceBaseUrl = () =>
  resolveServiceBaseUrl(
    process.env.REACT_APP_SWAGGER_SERVICE_BASE_URL,
    'http://localhost:8080'
  );

export const getAssetServiceBaseUrl = () =>
  resolveServiceBaseUrl(
    process.env.REACT_APP_ASSET_SERVICE_BASE_URL,
    'http://localhost:8081'
  );

export const getJavaApiBaseUrl = () =>
  resolveServiceBaseUrl(
    process.env.REACT_APP_API_BASE_URL,
    'http://localhost:8080'
  );
